import { createActions } from 'redux-actions'

export const INIT_INTERNAL_CATEGORY_INFO = "INIT_CATEGORY_INFO";

export const REQUEST_INTERNAL_CATEGORY_START = "REQUEST_INTERNAL_CATEGORY_START";
export const REQUEST_INTERNAL_CATEGORY_SUCCESS = "REQUEST_INTERNAL_CATEGORY_SUCCESS";
export const REQUEST_INTERNAL_CATEGORY_FAIL = "REQUEST_INTERNAL_CATEGORY_FAIL";

export const POST_INTERNAL_CATEGORY_START = "POST_INTERNAL_CATEGORY_START";
export const POST_INTERNAL_CATEGORY_SUCCESS = "POST_INTERNAL_CATEGORY_SUCCESS";
export const POST_INTERNAL_CATEGORY_FAIL = "POST_INTERNAL_CATEGORY_FAIL";

export const PATCH_INTERNAL_CATEGORY_START = "PATCH_INTERNAL_CATEGORY_START";
export const PATCH_INTERNAL_CATEGORY_SUCCESS = "PATCH_INTERNAL_CATEGORY_SUCCESS";

export const DELETE_INTERNAL_CATEGORY_START = "DELETE_INTERNAL_CATEGORY_START";
export const DELETE_INTERNAL_CATEGORY_SUCCESS = "DELETE_INTERNAL_CATEGORY_SUCCESS";
export const DELETE_INTERNAL_CATEGORY_FAIL = "DELETE_INTERNAL_CATEGORY_FAIL";

export const REQUEST_DETAIL_INTERNAL_CATEGORY_START = "REQUEST_DETAIL_INTERNAL_CATEGORY_START";
export const REQUEST_DETAIL_INTERNAL_CATEGORY_SUCCESS = "REQUEST_DETAIL_INTERNAL_CATEGORY_SUCCESS";
export const REQUEST_DETAIL_INTERNAL_CATEGORY_FAIL = "REQUEST_DETAIL_INTERNAL_CATEGORY_FAIL";

export const PUT_INTERNAL_CATEGORY_START = "PUT_INTERNAL_CATEGORY_START";
export const PUT_INTERNAL_CATEGORY_SUCCESS = "PUT_INTERNAL_CATEGORY_SUCCESS";
export const PUT_INTERNAL_CATEGORY_FAIL = "PUT_INTERNAL_CATEGORY_FAIL";

export const DELETE_MULTIPLE_INTERNAL_CATEGORY_START = "DELETE_MULTIPLE_INTERNAL_CATEGORY_START";
export const DELETE_MULTIPLE_INTERNAL_CATEGORY_SUCCESS = "DELETE_MULTIPLE_INTERNAL_CATEGORY_SUCCESS";
export const DELETE_MULTIPLE_INTERNAL_CATEGORY_FAIL = "DELETE_MULTIPLE_INTERNAL_CATEGORY_FAIL";

export const PATCH_MULTIPLE_INTERNAL_CATEGORY_START = "PATCH_MULTIPLE_INTERNAL_CATEGORY_START";
export const PATCH_MULTIPLE_INTERNAL_CATEGORY_SUCCESS = "PATCH_MULTIPLE_INTERNAL_CATEGORY_SUCCESS";
export const PATCH_MULTIPLE_INTERNAL_CATEGORY_FAIL = "PATCH_MULTIPLE_INTERNAL_CATEGORY_FAIL";

export const PUT_MULTIPLE_INTERNAL_CATEGORY_START = "PUT_MULTIPLE_INTERNAL_CATEGORY_START";
export const PUT_MULTIPLE_INTERNAL_CATEGORY_SUCCESS = "PUT_MULTIPLE_INTERNAL_CATEGORY_SUCCESS";
export const PUT_MULTIPLE_INTERNAL_CATEGORY_FAIL = "PUT_MULTIPLE_INTERNAL_CATEGORY_FAIL";

export const {

    initInternalCategoryInfo,
    requestInternalCategoryStart,
    requestInternalCategorySuccess,
    requestInternalCategoryFail,

    postInternalCategoryStart,
    postInternalCategorySuccess,
    postInternalCategoryFail,

    patchInternalCategoryStart,
    patchInternalCategorySuccess,

    deleteInternalCategoryStart,
    deleteInternalCategorySuccess,
    deleteInternalCategoryFail,

    requestDetailInternalCategoryStart,
    requestDetailInternalCategorySuccess,
    requestDetailInternalCategoryFail,

    putInternalCategoryStart,
    putInternalCategorySuccess,
    putInternalCategoryFail,

    deleteMultipleInternalCategoryStart,
    deleteMultipleInternalCategorySuccess,
    deleteMultipleInternalCategoryFail,

    patchMultipleInternalCategoryStart,
    patchMultipleInternalCategorySuccess,
    patchMultipleInternalCategoryFail,

    putMultipleInternalCategoryStart,
    putMultipleInternalCategorySuccess,
    putMultipleInternalCategoryFail,

} = createActions({

    [INIT_INTERNAL_CATEGORY_INFO]: (req) => ({ req }),

    [REQUEST_INTERNAL_CATEGORY_START]: (req) => ({ ...req }),
    [REQUEST_INTERNAL_CATEGORY_SUCCESS]: (res) => ({ res }),
    [REQUEST_INTERNAL_CATEGORY_FAIL]: (res) => ({ res }),

    [POST_INTERNAL_CATEGORY_START]: (req) => ({ ...req }),
    [POST_INTERNAL_CATEGORY_SUCCESS]: (res) => ({ res }),
    [POST_INTERNAL_CATEGORY_FAIL]: (res) => ({ res }),

    [PATCH_INTERNAL_CATEGORY_START]: (req) => ({ ...req }),
    [PATCH_INTERNAL_CATEGORY_SUCCESS]: (res) => ({ res }),

    [DELETE_INTERNAL_CATEGORY_START]: (req) => ({ ...req }),
    [DELETE_INTERNAL_CATEGORY_SUCCESS]: (res) => ({ res }),
    [DELETE_INTERNAL_CATEGORY_FAIL]: (res) => ({ res }),

    [REQUEST_DETAIL_INTERNAL_CATEGORY_START]: (req) => ({ ...req }),
    [REQUEST_DETAIL_INTERNAL_CATEGORY_SUCCESS]: (res) => ({ res }),
    [REQUEST_DETAIL_INTERNAL_CATEGORY_FAIL]: (res) => ({ res }),

    [PUT_INTERNAL_CATEGORY_START]: (req) => ({ ...req }),
    [PUT_INTERNAL_CATEGORY_SUCCESS]: (res) => ({ res }),
    [PUT_INTERNAL_CATEGORY_FAIL]: (res) => ({ res }),

    [DELETE_MULTIPLE_INTERNAL_CATEGORY_START]: (req) => ({ ...req }),
    [DELETE_MULTIPLE_INTERNAL_CATEGORY_SUCCESS]: (res) => ({ res }),
    [DELETE_MULTIPLE_INTERNAL_CATEGORY_FAIL]: (res) => ({ res }),

    [PATCH_MULTIPLE_INTERNAL_CATEGORY_START]: (req) => ({ ...req }),
    [PATCH_MULTIPLE_INTERNAL_CATEGORY_SUCCESS]: (res) => ({ res }),
    [PATCH_MULTIPLE_INTERNAL_CATEGORY_FAIL]: (res) => ({ res }),

    [PUT_MULTIPLE_INTERNAL_CATEGORY_START]: (req) => ({ ...req }),
    [PUT_MULTIPLE_INTERNAL_CATEGORY_SUCCESS]: (res) => ({ res }),
    [PUT_MULTIPLE_INTERNAL_CATEGORY_FAIL]: (res) => ({ res }),


})


